/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { useEffect, useRef } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

const useScrollToTopOnNavigation = () => {
  const location = useLocation();
  const prevPath = useRef<string>(location.pathname ?? "/");
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== NavigationType.Pop && location.pathname !== prevPath.current) {
      window.scrollTo(0, 0);
      prevPath.current = location.pathname;
    }
  }, [location.pathname, navigationType]);
};

export default useScrollToTopOnNavigation;
